import React from "react";
import styled from "styled-components";

const Separator = styled.div`
  background-color: rgba(237, 238, 233, 0.4);
  height: 1px;

  ${props => props.separatorStyle};
`;

export default ({ separatorStyle }) => {
  return <Separator separatorStyle={separatorStyle} />;
};



// WEBPACK FOOTER //
// ./src/components/Separator/index.js